import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const parseContactPhone = (value: unknown) => {
  if (typeof value !== 'string') return undefined;

  return parsePhoneNumberFromString(value.trim(), { defaultCountry: 'RU', extract: false });
};

export const normalizePhone = (value: unknown): string | undefined => {
  const phone = parseContactPhone(value);
  return phone?.isValid() ? phone.number : undefined;
};

export const formatPhone = (value: string | null | undefined): string => {
  const phone = parseContactPhone(value);
  if (phone?.countryCallingCode === '7' && phone.nationalNumber.length === 10) {
    const digits = phone.nationalNumber;
    return `+7 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8)}${phone.ext ? `#${phone.ext}` : ''}`;
  }
  return phone?.isValid() ? phone.formatInternational() : (value ?? '');
};
